export const itTranslations: Record<string, string> = {
  'app.badge': 'Lumen Hospitality DPSK',
  'nav.overview': 'Panoramica',
  'nav.overviewDesc': 'Stato operativo, orchestrazione e canali di delivery',
  'nav.reception': 'Reception',
  'nav.receptionDesc': 'Liste operative, nuova emissione e import massivo',
  'nav.administration': 'Amministrazione',
  'nav.administrationDesc':
    'Liste e form dedicati per tenant, vendor, location, utenti e infrastruttura',
  'shell.consoleTitle': 'Console Operativa',
  'shell.consoleDescription':
    'Dashboard multi-tenant per flussi PMS, processi reception, provisioning del controller di rete e distribuzione DPSK.',
  'shell.livePosture': 'Stato operativo',
  'shell.loadingLocation': 'Contesto location in caricamento',
  'shell.healthy': 'Flusso operativo regolare',
  'shell.attention': 'Attenzione sul canale di consegna',
  'shell.authSession': 'Sessione autenticata',
  'shell.guestOperator': 'Operatore demo',
  'shell.noRole': 'Nessun ruolo',
  'shell.currentWorkspace': 'Workspace corrente',
  'shell.workspaceDescription': 'Contesto attivo per la pagina selezionata.',
  'shell.filters': 'Filtri',
  'shell.tenant': 'Tenant',
  'shell.location': 'Hotel / Location',
  'shell.language': 'Lingua',
  'shell.theme': 'Tema',
  'shell.theme.system': 'Sistema',
  'shell.theme.light': 'Chiaro',
  'shell.loadingData': 'Aggiornamento dati in corso',
  'shell.searchTenant': 'Cerca tenant',
  'shell.searchLocation': 'Cerca hotel o location',
  'shell.noSearchResults': 'Nessun risultato disponibile',
  'shell.closeFilters': 'Chiudi filtri',
  'dialog.cancel': 'Annulla',
  'dialog.deleteTitle': 'Conferma eliminazione',
  'dialog.extendTitle': 'Conferma estensione',
  'dialog.revokeTitle': 'Conferma revoca',
  'shell.noPms': 'Nessun PMS associato',
  'shell.noController': 'Nessun controller associato',
  'shell.tvOn': 'TV attiva',
  'shell.tvPending': 'TV in attesa',
  'shell.emailOn': 'Email attiva',
  'shell.emailPending': 'Email in attesa',
  'shell.exitSession': 'Esci',
  'auth.mode.mock': 'Modalità demo',
  'auth.mode.keycloak': 'Keycloak',
  'login.badge': 'Console operativa hospitality',
  'login.title': 'Accesso sicuro alla piattaforma hospitality.',
  'login.description':
    'Gestisci tenant, location, utenti, vendor e credenziali Wi-Fi da una console unica, progettata per l’operatività quotidiana.',
  'login.inputTitle': 'Tenant e location',
  'login.inputBody': 'Controlla strutture, unità, vendor e configurazioni operative in un unico punto.',
  'login.logicTitle': 'Reception e credenziali',
  'login.logicBody':
    'Emetti, rinnova e monitora i codici Wi-Fi per ospiti, staff ed eventi senza passaggi aggiuntivi.',
  'login.outputTitle': 'Controllo operativo',
  'login.outputBody': 'Consulta stato del servizio, code e distribuzione credenziali in modo immediato.',
  'login.accessMode': 'Accesso',
  'login.demoWorkspace': 'Prova la piattaforma',
  'login.keycloakWorkspace': 'Bentornato',
  'login.demoDescription':
    'Apri l’ambiente dimostrativo per esplorare i flussi principali con dati simulati.',
  'login.keycloakDescription':
    'Accedi con il tuo account aziendale per continuare.',
  'login.realm': 'Realm',
  'login.clientId': 'Client ID',
  'login.endpoint': 'Endpoint',
  'login.enterDemo': 'Apri dashboard demo',
  'login.continueKeycloak': 'Accedi alla piattaforma',
  'login.readyTitle': 'Gestione centralizzata',
  'login.readyBody':
    'Trovi tenant, location, unità, utenti e cataloghi in un’unica console operativa.',
  'login.supportTitle': 'Operazioni quotidiane',
  'login.supportBody':
    'Puoi lavorare su reception, credenziali Wi-Fi e configurazioni di servizio con un flusso semplice.',
  'login.demoNote': 'L’ambiente demo usa dati simulati ed è pensato per la sola esplorazione.',
  'login.switchNote':
    'Se hai problemi di accesso contatta l’amministratore del servizio.',
  'overview.context': 'Panoramica operativa',
  'overview.title': 'Stato della location selezionata',
  'overview.subtitle':
    'Indicatori rapidi sull’uso DPSK, sul mapping VLAN e sul carico operativo del sito.',
  'overview.card.active.label': 'Identità attive',
  'overview.card.active.caption': 'DPSK attualmente valide sulla location selezionata',
  'overview.card.scheduled.label': 'Arrivi schedulati',
  'overview.card.scheduled.caption': 'Credenziali già create in attesa di check-in o evento',
  'overview.card.mapped.label': 'Unità mappate',
  'overview.card.mapped.caption': '{rooms} camere, {publicAreas} aree comuni, {eventHalls} sale evento',
  'overview.card.daily.label': 'Volume giornaliero',
  'overview.card.daily.caption': 'Carico previsto tra PMS, reception e richieste manuali',
  'overview.locationHealth': 'Postura servizi',
  'overview.deliveryChannels': 'Canali di consegna',
  'overview.connected': 'Connesso',
  'overview.fallback': 'Fallback attivo',
  'overview.accounting': 'Accounting',
  'overview.accountingBody': 'I log RADIUS restano centralizzati per compliance e analytics.',
  'overview.operationalFlow': 'Flusso operativo',
  'overview.flowAligned': 'Allineato agli scenari del documento',
  'overview.channelMix': 'Mix canali',
  'overview.distributionSplit': 'Ripartizione delivery',
  'overview.channelShare': '{share}% del totale visibile',
  'overview.infrastructure': 'Unità e VLAN',
  'overview.infrastructureDesc': 'Camere, aree comuni e sale evento disponibili sulla location.',
  'overview.alerts': 'Cruscotto attenzioni',
  'overview.alertsTitle': 'Rischi e anomalie correnti',
  'overview.noAlerts': 'Nessuna anomalia aperta sulla location corrente.',
  'overview.queue': 'Coda background',
  'overview.queueTitle': 'Stato import massivi',
  'overview.queueProgress': '{processed}/{total} processati, VLAN target {vlan}',
  'overview.credentials': 'Credenziali recenti',
  'overview.credentialsTitle': 'Ultime DPSK emesse',
  'overview.table.guest': 'Ospite',
  'overview.table.space': 'Unità',
  'overview.table.type': 'Tipo',
  'overview.table.vlan': 'VLAN',
  'overview.table.ssid': 'SSID',
  'overview.table.panMode': 'Modalità PAN',
  'overview.table.source': 'Origine',
  'overview.table.channels': 'Canali',
  'overview.table.validity': 'Validità',
  'overview.table.devices': 'Dispositivi',
  'table.pagination.previous': 'Precedente',
  'table.pagination.next': 'Successiva',
  'table.pagination.summary': '{from}-{to} di {total}',
  'overview.flow.trigger.title': 'Trigger PMS / Reception',
  'overview.flow.trigger.body': 'Webhook, form operatore o CSV generano la richiesta di accesso.',
  'overview.flow.normalize.title': 'Normalizzazione identità',
  'overview.flow.normalize.body':
    'La piattaforma assegna hotel, unità, VLAN e finestra temporale di validità.',
  'overview.flow.provision.title': 'Provisioning controller di rete',
  'overview.flow.provision.body':
    'La DPSK viene associata alla VLAN mappata e al suo ciclo di vita.',
  'overview.flow.deliver.title': 'Distribuzione canali',
  'overview.flow.deliver.body': 'TV, email, dashboard o stampa ricevono QR code e password.',
  'overview.flow.monitor.title': 'Monitoraggio e accounting',
  'overview.flow.monitor.body':
    'Uso, code, adozione canali e accounting restano visibili per operations.',
  'reception.pageKicker': 'Gestione reception',
  'reception.pageTitle': 'Emissione e ciclo di vita delle DPSK',
  'reception.pageDescription':
    'L’area reception è organizzata in pagine dedicate: lista codici, nuova emissione manuale e bulk upload.',
  'reception.tab.issue': 'Emissione',
  'reception.tab.codes': 'Gestione codici',
  'reception.tab.bulk': 'Bulk upload',
  'reception.summary.active': 'Attive',
  'reception.summary.scheduled': 'Schedulate',
  'reception.summary.archived': 'Archiviate',
  'reception.summary.queue': 'Job bulk',
  'reception.issue.kicker': 'Emissione manuale',
  'reception.issue.title': 'Crea una DPSK per ospiti e casi eccezionali',
  'reception.issue.description':
    'Per walk-in, fornitori, bar o fallback rispetto al PMS. Genera QR code e password in chiaro.',
  'reception.fields.firstName': 'Nome',
  'reception.fields.lastName': 'Cognome',
  'reception.fields.email': 'Email',
  'reception.fields.space': 'Unità',
  'reception.fields.selectSpace': 'Seleziona un’unità',
  'reception.fields.reference': 'Riferimento prenotazione / voucher',
  'reception.fields.validFrom': 'Valida da',
  'reception.fields.validUntil': 'Valida fino a',
  'reception.fields.devicesAllowed': 'Dispositivi consentiti',
  'reception.fields.category': 'Categoria ospite',
  'reception.fields.deliveryChannels': 'Canali di consegna',
  'reception.fields.serviceMode': 'Modalità servizio',
  'reception.fields.notes': 'Note operative',
  'reception.category.guest': 'Guest',
  'reception.category.visitor': 'Visitor',
  'reception.category.iot': 'IoT',
  'reception.category.staff': 'Staff',
  'reception.category.journalist': 'Giornalista',
  'reception.category.relator': 'Relatore',
  'reception.categoryDescription.staff': 'Il codice viene creato sulla VLAN preimpostata.',
  'reception.categoryDescription.iot': 'Il codice viene creato sulla VLAN preimpostata.',
  'reception.categoryDescription.visitor': 'Il codice viene creato sulla VLAN preimpostata.',
  'reception.categoryDescription.guest': 'Seleziona la camera per associare la VLAN relativa.',
  'reception.preview.kicker': 'Anteprima voucher',
  'reception.preview.title': 'Card operatore',
  'reception.preview.empty': 'Seleziona un’unità per vedere l’anteprima del QR.',
  'reception.preview.guest': 'Ospite',
  'reception.preview.ssidVlan': 'SSID / VLAN',
  'reception.preview.panMode': 'Modalità PAN',
  'reception.preview.expires': 'Scadenza',
  'reception.lastCreated': 'Ultimo codice creato',
  'reception.lastCreatedEmpty':
    'Genera una DPSK manuale per visualizzare qui il riepilogo del voucher.',
  'reception.generate': 'Genera DPSK',
  'reception.creating': 'Creazione...',
  'reception.codes.kicker': 'Gestione codici',
  'reception.codes.title': 'Filtra, estendi o revoca i voucher',
  'reception.filter.all': 'Tutti',
  'reception.filter.pms': 'PMS',
  'reception.filter.reception': 'Reception',
  'reception.filter.bulk': 'Bulk',
  'reception.searchPlaceholder': 'Cerca ospite o riferimento',
  'reception.activeList': 'Attivi / schedulati',
  'reception.archivedList': 'Archiviati / invalidi',
  'reception.actions.extend': '+24h',
  'reception.actions.revoke': 'Revoca',
  'reception.actions.new': 'Nuova DPSK',
  'reception.actions.backToCodes': 'Torna ai codici',
  'reception.actions.showQr': 'Mostra QR',
  'reception.actions.printQr': 'Stampa QR',
  'reception.confirm.extend': 'Estendere di 24 ore la scadenza del voucher {name}?',
  'reception.confirm.revoke': 'Revocare il voucher {name}?',
  'reception.activeEmpty': 'Nessun codice attivo o schedulato per i filtri correnti.',
  'reception.archivedEmpty': 'Nessun codice archiviato o revocato per i filtri correnti.',
  'reception.bulk.kicker': 'Caricamento massivo',
  'reception.bulk.title': 'Import CSV per gruppi ed eventi',
  'reception.bulk.loadFile': 'Carica file',
  'reception.bulk.mode': 'Modalità bulk',
  'reception.bulk.modeShared': 'VLAN condivisa di gruppo',
  'reception.bulk.modeIsolated': 'VLAN per unità / isolamento',
  'reception.bulk.defaultSpace': 'Unità di default',
  'reception.bulk.requestedBy': 'Richiesto da',
  'reception.bulk.csvBody': 'Contenuto CSV',
  'reception.bulk.queue': 'Accoda import',
  'reception.bulk.queueing': 'Accodamento...',
  'reception.bulk.templateHint':
    'Colonne attese: firstName, lastName, email, spaceId, validFrom, validUntil, devicesAllowed, bookingReference',
  'reception.bulk.jobs': 'Stato code',
  'reception.bulk.jobsTitle': 'Attività recenti',
  'reception.emptyLocation': 'Seleziona o crea una location con unità disponibili.',
  'reception.message.created': 'Creato {id} per {name}.',
  'reception.message.bulkQueued':
    'Job {id} accodato con {imported} identità ({status}).',
  'reception.message.extended': 'Validità estesa per {id} di 24 ore.',
  'reception.message.revoked': 'Codice {id} revocato.',
  'admin.pageKicker': 'Gestione amministrativa',
  'admin.pageTitle': 'Tenant, vendor controller/PMS, location e utenti',
  'admin.pageDescription':
    'L’area amministrativa usa pagine dedicate per tenant, cataloghi vendor controller e PMS, location, utenti e infrastruttura.',
  'admin.vendorHintTitle': 'Cataloghi vendor',
  'admin.vendorHintBody':
    'Prima di censire o aggiornare una location puoi configurare i cataloghi dei vendor controller e PMS, così i menu e i campi di configurazione saranno disponibili nei form delle location.',
  'admin.card.tenants.label': 'Tenant',
  'admin.card.tenants.caption': 'Portafoglio multi-tenant gestibile dal pannello',
  'admin.card.locations.label': 'Location',
  'admin.card.locations.caption': 'Hotel, resort e venue disponibili nel prototipo',
  'admin.card.users.label': 'Utenti',
  'admin.card.users.caption': 'Ruoli operativi e assegnazioni gestite via mock state',
  'admin.card.spaces.label': 'Unità / VLAN',
  'admin.card.spaces.caption': 'Inventario attuale della location selezionata',
  'admin.tab.tenants': 'Tenant',
  'admin.tab.locations': 'Location',
  'admin.tab.users': 'Utenti',
  'admin.tab.controllerVendors': 'Vendor controller',
  'admin.tab.pmsVendors': 'Vendor PMS',
  'admin.tab.infrastructure': 'Infrastruttura',
  'admin.tenants.kicker': 'Gestione tenant',
  'admin.tenants.title': 'Crea e aggiorna i tenant',
  'admin.locations.kicker': 'Gestione location',
  'admin.locations.title': 'Gestisci hotel, resort e venue',
  'admin.locations.filterHint':
    'Seleziona un tenant per vedere solo le location associate, senza usare i filtri operativi globali.',
  'admin.users.kicker': 'Gestione utenti',
  'admin.users.title': 'Ruoli, scope tenant e scope location',
  'admin.controllerVendors.kicker': 'Catalogo controller',
  'admin.controllerVendors.title': 'Censisci e gestisci i vendor controller',
  'admin.controllerVendors.empty': 'Nessun vendor controller censito.',
  'admin.controllerVendors.emptyHint':
    'Aggiungi il primo vendor controller per renderlo disponibile nel censimento delle location.',
  'admin.pmsVendors.kicker': 'Catalogo PMS',
  'admin.pmsVendors.title': 'Censisci e gestisci i vendor PMS',
  'admin.pmsVendors.empty': 'Nessun vendor PMS censito.',
  'admin.pmsVendors.emptyHint':
    'Aggiungi il primo vendor PMS per renderlo disponibile nel censimento delle location.',
  'admin.infrastructure.kicker': 'Inventory e integrazioni',
  'admin.infrastructure.title': 'Unità, VLAN e stato connettori',
  'admin.form.new': 'Nuovo',
  'admin.form.reset': 'Reset',
  'admin.form.create': 'Crea',
  'admin.form.update': 'Aggiorna',
  'admin.form.name': 'Nome',
  'admin.form.brand': 'Brand / descrizione',
  'admin.form.sla': 'SLA',
  'admin.form.coverage': 'Copertura DPSK %',
  'admin.form.city': 'Città',
  'admin.form.category': 'Categoria',
  'admin.form.pms': 'PMS',
  'admin.form.pmsVendor': 'Vendor PMS',
  'admin.form.pds': 'PDS config',
  'admin.form.controller': 'Controller',
  'admin.form.controllerVendor': 'Vendor controller',
  'admin.form.tv': 'Integrazione TV',
  'admin.form.email': 'Integrazione email',
  'admin.form.integrations': 'Integrazioni',
  'admin.form.state': 'Stato',
  'admin.form.dailyCheckIns': 'Check-in giornalieri',
  'admin.form.activeGuests': 'Ospiti attivi',
  'admin.form.bulkQueue': 'Coda bulk',
  'admin.form.note': 'Nota operativa',
  'admin.form.timezone': 'Timezone',
  'admin.form.linkedTenant': 'Tenant associato',
  'admin.form.role': 'Ruolo',
  'admin.form.status': 'Stato utente',
  'admin.form.tenantScope': 'Scope tenant',
  'admin.form.locationScope': 'Scope location',
  'admin.form.fieldSchema': 'Schema campi',
  'admin.form.fieldName': 'Nome campo',
  'admin.form.fieldType': 'Tipo campo',
  'admin.form.fieldsHelp': 'Definisci almeno un campo aggiuntivo per il vendor.',
  'admin.form.selectVendor': 'Seleziona vendor',
  'admin.form.selectVendorFirst': 'Seleziona prima un vendor per configurare i campi richiesti.',
  'admin.form.pmsConfiguration': 'Configurazione PMS',
  'admin.form.controllerConfiguration': 'Configurazione controller',
  'admin.form.vendorConfigurationHint':
    'Compila tutti i campi richiesti dal catalogo del vendor selezionato.',
  'admin.form.noPmsVendorsAvailable':
    'Nessun vendor PMS disponibile. Censisci prima il catalogo PMS.',
  'admin.form.noControllerVendorsAvailable':
    'Nessun vendor controller disponibile. Censisci prima il catalogo controller.',
  'admin.form.addField': 'Aggiungi campo',
  'admin.form.removeField': 'Rimuovi campo',
  'admin.form.createControllerVendor': 'Crea vendor controller',
  'admin.form.createPmsVendor': 'Crea vendor PMS',
  'admin.form.updateControllerVendor': 'Aggiorna vendor controller',
  'admin.form.updatePmsVendor': 'Aggiorna vendor PMS',
  'admin.form.controllerVendorNotFound': 'Vendor controller non trovato.',
  'admin.form.pmsVendorNotFound': 'Vendor PMS non trovato.',
  'admin.form.vendorFieldType.string': 'Stringa',
  'admin.form.vendorFieldType.number': 'Numero',
  'admin.form.vendorFieldType.boolean': 'Booleano',
  'admin.form.vendorFieldType.password': 'Password',
  'admin.form.unitType': 'Tipo unità',
  'admin.form.assignment': 'Assegnazione',
  'admin.form.unitStatus': 'Stato unità',
  'admin.list.portfolio': 'Portafoglio',
  'admin.list.properties': 'Proprietà',
  'admin.list.coverage': 'Copertura',
  'admin.list.alerts': 'Alert',
  'admin.list.noneTenants': 'Nessun tenant censito.',
  'admin.list.noneLocations': 'Nessuna location disponibile per il tenant selezionato.',
  'admin.tenants.emptyHint':
    'Crea il primo tenant per iniziare il censimento multi-tenant della piattaforma.',
  'admin.actions.edit': 'Modifica',
  'admin.actions.toggleStatus': 'Cambia stato',
  'admin.actions.newTenant': 'Nuovo tenant',
  'admin.actions.newLocation': 'Nuova location',
  'admin.actions.newUser': 'Nuovo utente',
  'admin.actions.newControllerVendor': 'Nuovo vendor controller',
  'admin.actions.newPmsVendor': 'Nuovo vendor PMS',
  'admin.actions.newRoomAssignment': 'Nuova unità',
  'admin.actions.assignRoom': 'Modifica unità',
  'admin.actions.manageInfrastructure': 'Infrastruttura',
  'admin.actions.backToLocation': 'Torna alla location',
  'admin.actions.backToList': 'Torna alla lista',
  'admin.actions.delete': 'Elimina',
  'admin.infrastructure.inventory': 'Inventario unità',
  'admin.infrastructure.roomAssignments': 'Assegnazioni per singola stanza',
  'admin.infrastructure.roomAssignmentsDesc':
    'Ogni camera viene mappata singolarmente con SSID, VLAN e modalità PAN. Da qui puoi creare o correggere l’assegnazione di una singola stanza.',
  'admin.infrastructure.locationScopeDesc':
    'Questa pagina appartiene alla location selezionata. L’assegnazione dell’infrastruttura viene gestita direttamente all’interno della location.',
  'admin.infrastructure.sharedSpaces': 'Unità condivise e sale evento',
  'admin.infrastructure.noRooms': 'Nessuna camera configurata per la location selezionata.',
  'admin.infrastructure.noSharedSpaces': 'Nessuna unità condivisa configurata.',
  'admin.infrastructure.roomPreview': 'Anteprima assegnazione',
  'admin.infrastructure.readiness': 'Readiness integrazioni',
  'admin.integrations.queuePlaceholder': 'Redis / RabbitMQ da definire in backend',
  'admin.integrations.pdsPlaceholder': 'Configurazione PDS da definire',
  'admin.form.createTenant': 'Crea tenant',
  'admin.form.updateTenant': 'Aggiorna tenant',
  'admin.form.tenantNotFound': 'Tenant non trovato.',
  'admin.form.createLocation': 'Crea location',
  'admin.form.updateLocation': 'Aggiorna location',
  'admin.form.locationNotFound': 'Location non trovata.',
  'admin.form.createUser': 'Crea utente',
  'admin.form.updateUser': 'Aggiorna utente',
  'admin.form.userNotFound': 'Utente non trovato.',
  'admin.form.roomName': 'Stanza',
  'admin.form.ssid': 'SSID',
  'admin.form.vlanId': 'VLAN',
  'admin.form.serviceVlanId': 'VLAN di servizio',
  'admin.form.networkId': 'ID rete',
  'admin.form.capacity': 'Capienza',
  'admin.form.createRoomAssignment': 'Crea unità',
  'admin.form.updateRoomAssignment': 'Aggiorna unità',
  'admin.form.roomAssignmentDescription':
    'Definisci il mapping Wi-Fi di una singola unità. La configurazione entra subito nell’inventory della location e nei flussi reception.',
  'admin.form.roomNotFound': 'Unità non trovata.',
  'admin.form.locationRequiredForRoom':
    'Seleziona prima una location per censire una unità.',
  'admin.message.tenantSaved': 'Tenant {name} salvato.',
  'admin.message.tenantDeleted': 'Tenant {name} eliminato.',
  'admin.message.locationSaved': 'Location {name} salvata.',
  'admin.message.locationDeleted': 'Location {name} eliminata.',
  'admin.message.userSaved': 'Utente {name} salvato.',
  'admin.message.userDeleted': 'Utente {name} eliminato.',
  'admin.message.controllerVendorSaved': 'Vendor controller {name} creato.',
  'admin.message.pmsVendorSaved': 'Vendor PMS {name} creato.',
  'admin.message.controllerVendorUpdated': 'Vendor controller {name} aggiornato.',
  'admin.message.pmsVendorUpdated': 'Vendor PMS {name} aggiornato.',
  'admin.message.controllerVendorDeleted': 'Vendor controller {name} eliminato.',
  'admin.message.pmsVendorDeleted': 'Vendor PMS {name} eliminato.',
  'admin.message.roomAssignmentSaved': 'Configurazione infrastruttura salvata per {name}.',
  'admin.message.roomDeleted': 'Stanza {name} eliminata.',
  'admin.confirm.deleteTenant': 'Eliminare il tenant {name} e tutte le location collegate?',
  'admin.confirm.deleteLocation': 'Eliminare la location {name} e la sua infrastruttura?',
  'admin.confirm.deleteUser': 'Eliminare l’utente {name}?',
  'admin.confirm.deleteRoom': 'Eliminare la stanza {name}?',
  'admin.confirm.deleteControllerVendor': 'Eliminare il vendor controller {name}?',
  'admin.confirm.deletePmsVendor': 'Eliminare il vendor PMS {name}?',
  'validation.required': 'Campo obbligatorio.',
  'validation.email': 'Inserisci una email valida.',
  'validation.minValue': 'Inserisci un valore valido.',
  'validation.fixErrors': 'Correggi i campi evidenziati prima di salvare.',
  'validation.dateOrder': 'La data di fine deve essere successiva alla data di inizio.',
  'validation.selectOne': 'Seleziona almeno un elemento.',
  'toast.dismiss': 'Chiudi notifica',
  'toast.error.network': 'Impossibile raggiungere il servizio backend.',
  'toast.error.badRequest': 'La richiesta non è valida.',
  'toast.error.unauthorized': 'Sessione non autorizzata. Effettua di nuovo l’accesso.',
  'toast.error.forbidden':
    'Non hai i permessi necessari per completare questa operazione.',
  'toast.error.notFound': 'La risorsa richiesta non è stata trovata.',
  'toast.error.conflict': 'L’operazione non può essere completata per un conflitto di stato.',
  'toast.error.validation': 'I dati inviati non sono validi.',
  'toast.error.server': 'Il server ha restituito un errore interno.',
  'toast.error.unavailable': 'Il servizio è temporaneamente non disponibile.',
  'toast.error.genericStatus': 'Errore HTTP {status}: richiesta non riuscita.',
  'toast.error.unexpected': 'Si è verificato un errore imprevisto durante la chiamata HTTP.',
  'channel.tv': 'TV',
  'channel.email': 'Email',
  'channel.dashboard': 'Dashboard',
  'channel.print': 'Stampa',
  'codeSource.pms': 'PMS',
  'codeSource.reception': 'Reception',
  'codeSource.bulk': 'Bulk',
  'queueStatus.queued': 'In coda',
  'queueStatus.running': 'In esecuzione',
  'queueStatus.completed': 'Completato',
  'queueStatus.attention': 'Attenzione',
  'spaceKind.room': 'Camera',
  'spaceKind.public-area': 'Area comune',
  'spaceKind.event-hall': 'Sala evento',
  'assignment.room': 'Camera',
  'assignment.group': 'Gruppo',
  'assignment.common': 'Comune',
  'panMode.private': 'Privata',
  'panMode.shared-group': 'Gruppo condiviso',
  'panMode.public': 'Comune',
  'role.tv-integration': 'TV integration',
  'role.platform-admin': 'Platform admin',
  'role.tenant-admin': 'Amministratore',
  'role.reception': 'Concierge',
  'role.operations': 'Operations',
  'locationCategory.hotel': 'Hotel',
  'locationCategory.resort': 'Resort',
  'locationCategory.conference': 'Conference venue',
  'locationState.active': 'Attiva',
  'locationState.disabled': 'Disabilitata',
  'locationState.pending': 'In attesa',
  'locationState.stable': 'Stabile',
  'locationState.attention': 'Attenzione',
  'unitStatus.available': 'Disponibile',
  'unitStatus.disabled': 'Disabilitata',
  'unitStatus.occupied': 'Occupata',
  'userStatus.active': 'Attivo',
  'userStatus.invited': 'Invitato',
  'userStatus.disabled': 'Disabilitato',
  'reception.tab.events': 'Eventi',
  'reception.actions.sendEmail': 'Invia tramite email',
  'reception.message.emailed': 'Codice {id} inviato tramite email.',
  'events.kicker': 'Wi-Fi per eventi',
  'events.title': 'Crea e gestisci gli accessi agli eventi',
  'events.name': 'Nome evento',
  'events.hall': 'Sala evento',
  'events.duration': 'Durata',
  'events.code': 'Codice evento',
  'events.isolation': 'Isolamento client',
  'events.network.loading': 'Caricamento reti...',
  'events.network.empty': 'Nessuna rete disponibile',
  'events.network.loadError': 'Impossibile caricare le reti',
  'events.isolated': 'Isolato',
  'events.shared': 'Accesso condiviso',
  'events.policy': 'Policy',
  'events.contactName': 'Nome del referente',
  'events.create': 'Nuovo evento',
  'events.edit': 'Modifica evento',
  'events.sendEmail': 'Invia il codice tramite email',
  'events.disable': 'Disabilita evento',
  'events.empty': 'Nessun evento configurato per questa location.',
  'events.message.saved': 'Evento {name} salvato.',
  'events.message.emailSent': 'Codice evento inviato a {email}.',
  'events.message.disabled': 'Evento {name} disabilitato.',
  'events.codes.kicker': 'Gestione ospiti e visitatori',
  'events.codes.manage': 'Gestisci codici evento',
  'events.codes.type': 'Tipologia codice',
  'events.codes.mode': 'Modalità di creazione',
  'events.codes.personal': 'Personal',
  'events.codes.manual': 'Manual',
  'events.codes.bulk': 'Import bulk',
  'events.codes.personalManual': 'Personal · Manual',
  'events.codes.personalBulk': 'Personal · Import bulk',
  'events.codes.group': 'Group',
  'events.codes.manualTitle': 'Crea un codice personale',
  'events.codes.bulkTitle': 'Importa codici personali da CSV',
  'events.codes.groupTitle': 'Crea un codice di gruppo',
  'events.codes.groupName': 'Nome gruppo',
  'events.codes.sendEmail': 'Invia il codice tramite email',
  'events.codes.service': 'Service',
  'events.codes.serviceHint': 'Usa la VLAN di servizio configurata per la sala evento.',
  'events.codes.serviceUnavailable': 'La sala selezionata non ha una VLAN di servizio configurata.',
  'events.codes.bulkHint': 'Colonne richieste: firstName, lastName, email, category, devicesAllowed. La durata e la sala vengono ereditate dall’evento; l’elaborazione è accodata per rispettare il rate limiting del vendor.',
  'events.codes.createPersonal': 'Crea codice personale',
  'events.codes.createGroup': 'Crea codice di gruppo',
  'events.codes.queueBulk': 'Accoda import CSV',
  'events.codes.personalCreated': 'Codice personale creato: {code}',
  'events.codes.groupCreated': 'Codice di gruppo creato: {code}',
  'events.codes.bulkQueued': 'Import {id} accodato: {imported} codici elaborati.',
  'reception.tab.hotel': 'Hotel', 'reception.hotel.description': 'Codici di camere e aree comuni da PMS o Concierge', 'reception.hotel.kicker': 'Codici Wi-Fi Hotel', 'reception.hotel.title': 'Gestisci i codici per camere e aree comuni',
  'admin.onboarding.kicker': 'Censimento guidato della location', 'admin.onboarding.title': 'Crea e configura una nuova location', 'admin.onboarding.description': 'Segui nell’ordine previsto il passaggio di consegne dal vendor a Lumen.',
  'admin.onboarding.step1': 'Controller', 'admin.onboarding.step2': 'Location', 'admin.onboarding.step3': 'Integrazioni', 'admin.onboarding.step4': 'Riepilogo', 'admin.onboarding.step5': 'Riepilogo',
  'admin.onboarding.locationKicker': 'Passaggio 2 · Dati location', 'admin.onboarding.locationTitle': 'Inserisci i dati della nuova location',
  'admin.onboarding.controllerKicker': 'Passaggio 1 · Collegamento vendor', 'admin.onboarding.controllerTitle': 'Configura il controller della location', 'admin.onboarding.controllerHelp': 'Hardware, RF, gruppi AP e SSID di base devono essere già configurati sulla piattaforma vendor.',
  'admin.onboarding.integrationsKicker': 'Passaggio 3 · Integrazioni opzionali', 'admin.onboarding.integrationsTitle': 'Configura PMS, TV e invio email', 'admin.onboarding.reviewKicker': 'Passaggio 4 · Riepilogo', 'admin.onboarding.reviewTitle': 'Conferma la configurazione della location', 'admin.onboarding.unitsNext': 'Dopo il salvataggio configura camere, unità condivise e sale evento con VLAN e Network.', 'admin.onboarding.saveContinue': 'Salva e configura le unità',
  'admin.unitsBulk.action': 'Import bulk',
  'admin.unitsBulk.kicker': 'Importazione massiva unità',
  'admin.unitsBulk.title': 'Importa unità da CSV',
  'admin.unitsBulk.description': 'Crea camere, aree condivise e sale evento in un’unica operazione.',
  'admin.unitsBulk.loadFile': 'Carica CSV',
  'admin.unitsBulk.csv': 'CSV unità',
  'admin.unitsBulk.hint': 'Colonne: name, type, vlanId, serviceVlanId, networkId, panMode, capacity, assignment, status. Obbligatorie: name, type, vlanId, networkId.',
  'admin.unitsBulk.importing': 'Importazione...',
  'admin.unitsBulk.import': 'Importa unità',
  'admin.unitsBulk.completed': '{count} unità importate.',
  'admin.unitsBulk.invalid': 'CSV non valido: {error}',
  'admin.unitsBulk.noRows': 'Nessuna riga dati presente.',
  'admin.unitsBulk.missingColumns': 'Colonne mancanti: {columns}.',
  'admin.unitsBulk.rowError': 'Valori non validi alla riga {row}.',
};
